import { render, staticRenderFns } from "./indemnityContract.vue?vue&type=template&id=10ac5f9b&scoped=true"
import script from "./indemnityContract.vue?vue&type=script&lang=js"
export * from "./indemnityContract.vue?vue&type=script&lang=js"
import style0 from "./indemnityContract.vue?vue&type=style&index=0&id=10ac5f9b&prod&lang=less"
import style1 from "./indemnityContract.vue?vue&type=style&index=1&id=10ac5f9b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ac5f9b",
  null
  
)

export default component.exports